module.exports = __webpack_public_path__ + "assets/img/26_828_big.062740c6.jpg";